<template><svg
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
>
    <path d="M0.549369 3.97028C0.81113 3.70327 1.22075 3.679 1.50939 3.89746L1.59209 3.97028L7.50008 9.99702L13.4081 3.97028C13.6698 3.70327 14.0795 3.679 14.3681 3.89746L14.4508 3.97028C14.7126 4.2373 14.7364 4.65513 14.5222 4.94956L14.4508 5.03391L8.02144 11.5922C7.75968 11.8592 7.35006 11.8835 7.06142 11.665L6.97872 11.5922L0.549368 5.03391C0.26143 4.7402 0.26143 4.264 0.549369 3.97028Z"/>
</svg>
</template>